import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48d29583"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-4 flex flex-col gap-4 font-inter" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"text-2xl font-semibold font-quicksand\" data-v-48d29583>Mesas</h1><div class=\"flex items-center gap-4\" data-v-48d29583><div class=\"flex gap-2 items-center\" data-v-48d29583><div class=\"h-4 w-4 bg-red-500\" data-v-48d29583></div> Ocupado </div><div class=\"flex gap-2 items-center\" data-v-48d29583><div class=\"h-4 w-4 bg-green-500\" data-v-48d29583></div> Livre </div></div>", 2)
const _hoisted_4 = { class: "grid grid-cols-12 gap-4" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "pb-4" }
const _hoisted_7 = { class: "font-semibold" }
const _hoisted_8 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_9 = {
  key: 1,
  class: "text-xs"
}
const _hoisted_10 = { class: "p-4 flex flex-col gap-4" }
const _hoisted_11 = { class: "flex justify-between items-center" }
const _hoisted_12 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z",
  style: {"fill":"currentcolor"}
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-semibold" }, "Cadastro de consumidor", -1))
const _hoisted_16 = { class: "bg-zinc-800 text-white font-semibold px-3 py-1 rounded-lg flex items-center gap-2" }
const _hoisted_17 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.8rem","height":"1.8rem"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M5,4H19A2,2 0 0,1 21,6V18A2,2 0 0,1 19,20H5A2,2 0 0,1 3,18V6A2,2 0 0,1 5,4M5,8V12H11V8H5M13,8V12H19V8H13M5,14V18H11V14H5M13,14V18H19V14H13Z",
  style: {"fill":"#fff"}
}, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "flex flex-col gap-2" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-md font-medium",
  for: "name"
}, [
  /*#__PURE__*/_createTextVNode("Nome "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 text-sm" }, "(opcional)")
], -1))
const _hoisted_22 = { class: "flex flex-col gap-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "text-md font-medium",
  for: "description"
}, [
  /*#__PURE__*/_createTextVNode("Descrição "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 text-sm" }, "(opcional)")
], -1))
const _hoisted_24 = { class: "" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "p-4 flex flex-col gap-4" }
const _hoisted_29 = { class: "flex justify-between items-center" }
const _hoisted_30 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z",
  style: {"fill":"currentcolor"}
}, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-semibold" }, "Transferir mesa", -1))
const _hoisted_34 = { class: "flex justify-between items-center bg-gray-100 p-4 rounded-xl" }
const _hoisted_35 = { class: "flex flex-col items-center" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-gray-500 uppercase font-bold" }, "DE", -1))
const _hoisted_37 = { class: "bg-zinc-800 text-white font-semibold px-3 py-1 rounded-lg flex items-center gap-2" }
const _hoisted_38 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M4,15V9H12V4.16L19.84,12L12,19.84V15H4Z",
  style: {"fill":"currentcolor"}
}, null, -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = { class: "flex flex-col items-center" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-gray-500 uppercase font-bold" }, "PARA", -1))
const _hoisted_43 = {
  key: 0,
  class: "bg-primary text-white font-semibold px-3 py-1 rounded-lg"
}
const _hoisted_44 = {
  key: 1,
  class: "text-sm font-semibold text-gray-400"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500" }, "Selecione a mesa de destino:", -1))
const _hoisted_46 = { class: "flex flex-wrap gap-2 overflow-auto max-h-60 p-1" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { class: "flex gap-4 mt-4" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z",
  style: {"fill":"currentcolor"}
}, null, -1))
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = { class: "p-4 flex flex-col gap-4" }
const _hoisted_55 = { class: "flex justify-between items-center border-b pb-4" }
const _hoisted_56 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z",
  style: {"fill":"currentcolor"}
}, null, -1))
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = { class: "flex gap-2 items-center" }
const _hoisted_60 = { class: "bg-zinc-800 text-white font-semibold px-4 py-2 rounded-lg flex items-center gap-2" }
const _hoisted_61 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.2rem","height":"1.2rem"}
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M21,9L17,5V8H10V10H17V13M7,11L3,15L7,19V16H14V14H7V11Z",
  style: {"fill":"currentcolor"}
}, null, -1))
const _hoisted_63 = [
  _hoisted_62
]
const _hoisted_64 = { class: "flex flex-col gap-3 py-2" }
const _hoisted_65 = { class: "p-4 flex justify-between items-center hover:bg-gray-50 transition duration-200" }
const _hoisted_66 = { class: "flex items-center gap-4 flex-1" }
const _hoisted_67 = { class: "bg-gray-100 p-2 rounded-full text-gray-500" }
const _hoisted_68 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,6A2,2 0 0,0 10,8A2,2 0 0,0 12,10A2,2 0 0,0 14,8A2,2 0 0,0 12,6M12,13C14.67,13 20,14.33 20,17V20H4V17C4,14.33 9.33,13 12,13M12,14.9C9.03,14.9 5.9,16.36 5.9,17V18.1H18.1V17C18.1,16.36 14.97,14.9 12,14.9Z",
  style: {"fill":"currentcolor"}
}, null, -1))
const _hoisted_70 = [
  _hoisted_69
]
const _hoisted_71 = { class: "font-bold text-sm" }
const _hoisted_72 = { class: "text-xs text-gray-400 only-1-lines" }
const _hoisted_73 = { class: "flex gap-2" }
const _hoisted_74 = ["onClick"]
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12 2v20M2 12h20" })
], -1))
const _hoisted_76 = [
  _hoisted_75
]
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M7 21h10" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M12 3v18" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2" })
], -1))
const _hoisted_78 = ["onClick"]
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3 6h18" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "10",
    x2: "10",
    y1: "11",
    y2: "17"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "14",
    x2: "14",
    y1: "11",
    y2: "17"
  })
], -1))
const _hoisted_80 = [
  _hoisted_79
]
const _hoisted_81 = {
  key: 0,
  class: "border-t bg-gray-50 p-4"
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-400 text-center" }, "Carregando...", -1))
const _hoisted_83 = [
  _hoisted_82
]
const _hoisted_84 = {
  key: 1,
  class: "border-t bg-gray-50 p-4"
}
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-bold text-gray-600 mb-3" }, "Pedidos da comanda:", -1))
const _hoisted_86 = {
  key: 0,
  class: "flex flex-col gap-2 max-h-48 overflow-y-auto"
}
const _hoisted_87 = { class: "flex justify-between items-start mb-1" }
const _hoisted_88 = { class: "font-bold text-gray-700" }
const _hoisted_89 = { class: "text-gray-600" }
const _hoisted_90 = {
  key: 1,
  class: "text-xs text-gray-400 text-center py-2"
}
const _hoisted_91 = { class: "mt-4 border-t pt-4 flex flex-col gap-3" }
const _hoisted_92 = ["disabled"]
const _hoisted_93 = { key: 0 }
const _hoisted_94 = { key: 1 }
const _hoisted_95 = { class: "p-6 flex flex-col gap-4" }
const _hoisted_96 = { class: "flex justify-between items-center border-b pb-4" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-bold" }, "Dividir Conta", -1))
const _hoisted_98 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z",
  fill: "currentColor"
}, null, -1))
const _hoisted_100 = [
  _hoisted_99
]
const _hoisted_101 = { class: "flex flex-col gap-4" }
const _hoisted_102 = { class: "bg-gray-50 rounded-2xl p-4" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500 uppercase font-bold mb-2" }, "Número de Pessoas", -1))
const _hoisted_104 = { class: "flex items-center justify-between" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5 12h14" })
], -1))
const _hoisted_106 = [
  _hoisted_105
]
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12 5v14M5 12h14" })
], -1))
const _hoisted_108 = [
  _hoisted_107
]
const _hoisted_109 = { class: "bg-blue-50 rounded-2xl p-4 border border-blue-100" }
const _hoisted_110 = { class: "text-sm text-blue-800 font-bold" }
const _hoisted_111 = { class: "text-sm text-blue-700 mt-1" }
const _hoisted_112 = ["disabled"]
const _hoisted_113 = { class: "p-6 flex flex-col gap-4" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-bold" }, "Cobrança - Divisão de Conta", -1))
const _hoisted_115 = { class: "space-y-3" }
const _hoisted_116 = { class: "flex items-center gap-3" }
const _hoisted_117 = {
  key: 0,
  class: "font-bold text-sm"
}
const _hoisted_118 = {
  key: 1,
  class: "font-bold text-sm"
}
const _hoisted_119 = { class: "font-bold text-gray-800" }
const _hoisted_120 = { class: "text-xs text-gray-500" }
const _hoisted_121 = ["onClick", "disabled"]
const _hoisted_122 = {
  key: 1,
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  class: "text-green-500"
}
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M22 11.08V12a10 10 0 1 1-5.93-9.14" }, null, -1))
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M22 4 12 14.01l-3-3" }, null, -1))
const _hoisted_125 = [
  _hoisted_123,
  _hoisted_124
]
const _hoisted_126 = { class: "bg-blue-50 rounded-2xl p-4 border border-blue-100" }
const _hoisted_127 = { class: "text-sm font-bold text-blue-900" }
const _hoisted_128 = { class: "w-full bg-blue-200 rounded-full h-2 mt-2" }

import MyModal from '@/components/modal/MyModal.vue';
import { computed, ref } from 'vue'
import { commands, selectedCommand, me, organizationSettings } from '@/global/state/GlobalState';
import axiosClient from '@/api/axios';
import { useToast } from 'vue-toastification';


export default /*#__PURE__*/_defineComponent({
  __name: 'TablesView',
  setup(__props) {

const isTableOpen = ref<boolean>(false)
const selectedTable = ref<number | null>(null)
const isAddCustomerModalOpen = ref<boolean>(false)
const isChangeTableNumberModalOpen = ref<boolean>(false)
const selectedTableNumberToTransfer = ref<number | undefined>(undefined)
const expandedTabId = ref<number | null>(null)
const tabOrders = ref<Record<number, any[]>>({})
const tabOrdersLoading = ref<boolean>(false)
const isAccountSplitModalOpen = ref<boolean>(false)
const isPaymentProgressModalOpen = ref<boolean>(false)
const splitNumberOfPeople = ref<number>(2)
const currentAccountSplit = ref<any>(null)
const splitPaymentProgress = ref<any[]>([])

const commandForm = ref<any>({
    number: null,
    name: '',
    description: ''
})
const isLoadingAction = ref<boolean>(false)

const toast = useToast()

const tableCount = computed(() => {
    let startingTable = me.value.metadata?.startingTable ?? 1
    let endTable = me.value.metadata?.endTable ?? (organizationSettings.value.quantityOfTables || 0)

    let tablesArr = []
    for (let i = startingTable; i <= endTable; i++) {
        tablesArr.push(i)
    }

    return tablesArr
})

const selectedTabTotalAmount = computed(() => {
    if (!selectedTable.value) return 0
    const tabs = commands.value[selectedTable.value!] || []
    let total = 0
    tabs.forEach((tab: any) => {
        total += tab.orderTotal || 0
    })
    return total
})

const paidCount = computed(() => {
    return splitPaymentProgress.value.filter((p: any) => p.paid).length
})

function onClickCommand(tableNumber: number){
    selectedTable.value = tableNumber
    if (commands.value[tableNumber] && commands.value[tableNumber].length > 0) {
        isTableOpen.value = true
    } else {
        openAddCustomerModal(tableNumber)
    }
}

function openAddCustomerModal(tableNumber: number) {
    commandForm.value.number = tableNumber
    commandForm.value.name = ''
    commandForm.value.description = ''
    isAddCustomerModalOpen.value = true
}

function openAddCustomerToExistingTable() {
    if (selectedTable.value) {
        openAddCustomerModal(selectedTable.value)
    }
}

async function storeCommand(){
    if (!commandForm.value.name && !commandForm.value.customerId) {
        // New API needs name or customerId
        // In this app, we mostly use descriptive names for waitlisting/commands
    }

    isLoadingAction.value = true
    axiosClient.post('/tabs', commandForm.value)
    .then((res: any) => {
        const tab = res.data.data || res.data
        if(!commands.value[tab.number]) commands.value[tab.number] = []
        commands.value[tab.number].push(tab)
        
        isLoadingAction.value = false
        isAddCustomerModalOpen.value = false
        toast.success("Cliente adicionado com sucesso")
    })
    .catch((err: any) => {
        isLoadingAction.value = false
        const message = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || "Erro ao adicionar cliente"
        toast.error(message)
    })
}

async function updateCommands(action: 'transfer' | 'paid', targetNumber?: number, tabId?: number){
    isLoadingAction.value = true

    const tabsToUpdate = tabId
        ? (commands.value[selectedTable.value!] || []).filter((c: any) => c.id == tabId)
        : (commands.value[selectedTable.value!] || [])

    if (tabsToUpdate.length === 0) {
        isLoadingAction.value = false
        return
    }

    try {
        for (const tab of tabsToUpdate) {
            const payload: any = {}
            if (action === 'transfer' && targetNumber) {
                payload.number = targetNumber
            } else if (action === 'paid') {
                payload.closedAt = new Date().toISOString()
            }

            await axiosClient.patch(`/tabs/${tab.id}`, payload)
        }

        // Refresh commands globally
        const res = await axiosClient.get('/tabs')
        let _commands: any = {}
        const tabs = res.data.data || res.data;
        if (Array.isArray(tabs)) {
            tabs.forEach((tab: any) => {
                const number = tab.number;
                if(!_commands[number]) _commands[number] = [];
                _commands[number].push(tab);
            })
        }
        commands.value = _commands

        toast.success(action === 'transfer' ? "Transferido com sucesso" : "Mesa fechada com sucesso")
        isTableOpen.value = false
        isChangeTableNumberModalOpen.value = false
        selectedTableNumberToTransfer.value = undefined
    } catch (err: any) {
        const message = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || "Erro ao processar ação"
        toast.error(message)
    } finally {
        isLoadingAction.value = false
    }
}

async function toggleTabOrders(tabId: number) {
    if (expandedTabId.value === tabId) {
        expandedTabId.value = null
    } else {
        expandedTabId.value = tabId
        if (!tabOrders.value[tabId]) {
            await loadTabOrders(tabId)
        }
    }
}

async function loadTabOrders(tabId: number) {
    try {
        tabOrdersLoading.value = true
        const res = await axiosClient.get(`/tabs/${tabId}`)
        const tab = res.data.data || res.data
        tabOrders.value[tabId] = tab.orders || []
    } catch (err: any) {
        toast.error("Erro ao carregar pedidos da comanda")
    } finally {
        tabOrdersLoading.value = false
    }
}

function getOrderStatusColor(status: string): string {
    const colors: Record<string, string> = {
        'PENDING': '#918373',
        'PREPARING': '#FF9B3D',
        'PREPARED': '#59A6F8',
        'DELIVERED': '#00c9a7',
        'CANCELED': '#F83535',
        'COMPLETED': '#00c9a7',
    }
    return colors[status] || '#999'
}

function getOrderStatusLabel(status: string): string {
    const labels: Record<string, string> = {
        'PENDING': 'pendente',
        'PREPARING': 'preparando',
        'PREPARED': 'preparado',
        'DELIVERED': 'entregue',
        'CANCELED': 'cancelado',
        'COMPLETED': 'concluído',
    }
    return labels[status] || status
}

function startAccountSplit() {
    if (!selectedTable.value) return
    const selectedTabObj = (commands.value[selectedTable.value!] || [])[0]
    if (!selectedTabObj) return

    isAccountSplitModalOpen.value = true
    splitNumberOfPeople.value = 2
}

async function createAccountSplit() {
    if (!selectedTable.value) return
    const selectedTabObj = (commands.value[selectedTable.value!] || [])[0]
    if (!selectedTabObj || splitNumberOfPeople.value < 2) return

    try {
        isLoadingAction.value = true
        const res = await axiosClient.post(`/tabs/${selectedTabObj.id}/split`, {
            numberOfPeople: splitNumberOfPeople.value
        })
        currentAccountSplit.value = res.data.data || res.data

        // Initialize payment progress array
        splitPaymentProgress.value = Array.from({ length: splitNumberOfPeople.value }, (_, index) => ({
            index,
            paid: false,
            amount: currentAccountSplit.value.amountPerPerson
        }))

        isAccountSplitModalOpen.value = false
        isPaymentProgressModalOpen.value = true
        toast.success('Divisão criada! Registre os pagamentos.')
    } catch (err: any) {
        const message = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || "Erro ao criar divisão"
        toast.error(message)
    } finally {
        isLoadingAction.value = false
    }
}

async function markPersonAsPaid(personIndex: number) {
    if (!currentAccountSplit.value) return

    try {
        isLoadingAction.value = true
        const res = await axiosClient.patch(`/tabs/split/${currentAccountSplit.value.id}/pay`, {
            personIndex,
            paymentMethod: 'cash' // Default payment method - can be customized
        })

        // Update local state
        splitPaymentProgress.value[personIndex].paid = true

        const result = res.data.data || res.data
        if (result.isComplete) {
            toast.success('Todos pagaram! Conta finalizada.')
            setTimeout(() => {
                isPaymentProgressModalOpen.value = false
                isAccountSplitModalOpen.value = false
                isTableOpen.value = false
                // Refresh commands
                updateCommands('paid')
            }, 1000)
        } else {
            toast.success(`Pessoa ${personIndex + 1} pagou. ${result.paidCount}/${result.totalPeople}`)
        }
    } catch (err: any) {
        const message = err.response?.data?.errors?.[0]?.message || "Erro ao registrar pagamento"
        toast.error(message)
    } finally {
        isLoadingAction.value = false
    }
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableCount.value, (tableNumber) => {
        return (_openBlock(), _createElementBlock("button", {
          key: tableNumber,
          onClick: ($event: any) => (onClickCommand(tableNumber)),
          class: _normalizeClass([!(_unref(commands)[tableNumber] && _unref(commands)[tableNumber].length > 0) ? 'bg-green-500':'bg-red-500', "col-span-4 text-white rounded-xl p-4 transition duration-200"])
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h3", _hoisted_7, "Mesa " + _toDisplayString(tableNumber), 1),
            (_unref(commands)[tableNumber] && _unref(commands)[tableNumber].length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(commands)[tableNumber].length) + " cliente(s)", 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_9, "livre"))
          ])
        ], 10, _hoisted_5))
      }), 128))
    ]),
    _createVNode(MyModal, {
      isOpen: isAddCustomerModalOpen.value,
      toggleModal: (v) => isAddCustomerModalOpen.value = v,
      zIndex: 50
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (isAddCustomerModalOpen.value = false)),
              class: "transition duration-200 hover:text-primary"
            }, [
              (_openBlock(), _createElementBlock("svg", _hoisted_12, _hoisted_14))
            ]),
            _hoisted_15
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("button", _hoisted_16, [
              (_openBlock(), _createElementBlock("svg", _hoisted_17, _hoisted_19)),
              _createTextVNode(" mesa " + _toDisplayString(selectedTable.value), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((commandForm.value.name) = $event)),
              type: "text",
              class: "p-4 py-3 border w-full rounded-xl input-primary text-sm md:text-md",
              placeholder: "ex: José Pedro",
              id: "name"
            }, null, 512), [
              [_vModelText, commandForm.value.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((commandForm.value.description) = $event)),
              type: "text",
              class: "p-4 py-3 border w-full rounded-xl input-primary text-sm md:text-md",
              placeholder: "ex: Camisa branca, calça preta",
              id: "description"
            }, null, 512), [
              [_vModelText, commandForm.value.description]
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("button", {
              onClick: storeCommand,
              class: "w-full p-4 py-3 text-white rounded-xl font-medium sm:mt-14 transition duration-200",
              style: _normalizeStyle({background:  !isLoadingAction.value ? '#323232' : '#f5f5f5', color: !isLoadingAction.value ? '#fff' : '#949494'}),
              disabled: isLoadingAction.value
            }, [
              (!isLoadingAction.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Adicionar cliente"))
                : (_openBlock(), _createElementBlock("span", _hoisted_27, "Carregando..."))
            ], 12, _hoisted_25)
          ])
        ])
      ]),
      _: 1
    }, 8, ["isOpen", "toggleModal"]),
    _createVNode(MyModal, {
      isOpen: isChangeTableNumberModalOpen.value,
      toggleModal: (v) => isChangeTableNumberModalOpen.value = v,
      zIndex: 80
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (isChangeTableNumberModalOpen.value = false)),
              class: "transition duration-200 hover:text-primary"
            }, [
              (_openBlock(), _createElementBlock("svg", _hoisted_30, _hoisted_32))
            ]),
            _hoisted_33
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createElementVNode("button", _hoisted_37, " Mesa " + _toDisplayString(selectedTable.value), 1)
            ]),
            (_openBlock(), _createElementBlock("svg", _hoisted_38, _hoisted_40)),
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              (selectedTableNumberToTransfer.value)
                ? (_openBlock(), _createElementBlock("button", _hoisted_43, " Mesa " + _toDisplayString(selectedTableNumberToTransfer.value), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_44, "?"))
            ])
          ]),
          _hoisted_45,
          _createElementVNode("div", _hoisted_46, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableCount.value, (tableNumber) => {
              return (_openBlock(), _createElementBlock("button", {
                key: 'transfer-'+tableNumber,
                onClick: ($event: any) => (selectedTableNumberToTransfer.value = tableNumber),
                class: _normalizeClass([selectedTableNumberToTransfer.value == tableNumber ? 'bg-primary text-white':'border', "p-2 px-4 rounded-xl transition duration-200"])
              }, [
                (tableNumber < 10)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_48, "0"))
                  : _createCommentVNode("", true),
                _createTextVNode(_toDisplayString(tableNumber), 1)
              ], 10, _hoisted_47))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (isChangeTableNumberModalOpen.value = false)),
              class: "flex-1 p-3 bg-gray-200 rounded-xl font-semibold"
            }, "Cancelar"),
            _createElementVNode("button", {
              disabled: !selectedTableNumberToTransfer.value || selectedTableNumberToTransfer.value == selectedTable.value || isLoadingAction.value,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (updateCommands('transfer', selectedTableNumberToTransfer.value))),
              class: "flex-1 p-3 bg-primary text-white rounded-xl font-semibold disabled:opacity-50"
            }, " Transferir ", 8, _hoisted_50)
          ])
        ])
      ]),
      _: 1
    }, 8, ["isOpen", "toggleModal"]),
    (isTableOpen.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: openAddCustomerToExistingTable,
          class: "bg-primary fixed right-4 bottom-[20%] p-4 rounded-full z-40 box-shadow text-white"
        }, [
          (_openBlock(), _createElementBlock("svg", _hoisted_51, _hoisted_53))
        ]))
      : _createCommentVNode("", true),
    _createVNode(MyModal, {
      isOpen: isTableOpen.value,
      toggleModal: (v) => isTableOpen.value = v
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("button", {
              class: "transition duration-200 hover:text-primary",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (isTableOpen.value = false))
            }, [
              (_openBlock(), _createElementBlock("svg", _hoisted_56, _hoisted_58))
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("button", _hoisted_60, " Mesa " + _toDisplayString(selectedTable.value), 1),
              _createElementVNode("button", {
                class: "border p-2 px-3 rounded-lg hover:bg-gray-100 transition",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (isChangeTableNumberModalOpen.value = true))
              }, [
                (_openBlock(), _createElementBlock("svg", _hoisted_61, _hoisted_63))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_64, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_unref(commands)[selectedTable.value!] ?? []), (tab) => {
              return (_openBlock(), _createElementBlock("div", {
                key: tab.id,
                class: "border rounded-xl overflow-hidden"
              }, [
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      (_openBlock(), _createElementBlock("svg", _hoisted_68, _hoisted_70))
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("h6", _hoisted_71, _toDisplayString(tab.name || (tab.customer?.name || 'Cliente sem nome')), 1),
                      _createElementVNode("p", _hoisted_72, _toDisplayString(tab.description || 'Nenhuma descrição'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (toggleTabOrders(tab.id)),
                      class: "bg-blue-100 p-2 rounded-lg text-blue-600 hover:bg-blue-200 transition",
                      title: "Ver histórico"
                    }, _hoisted_76, 8, _hoisted_74),
                    _createVNode(_component_RouterLink, {
                      to: {name:'pos', params: {tab_id: tab.id}},
                      onClick: ($event: any) => (selectedCommand.value = tab),
                      class: "bg-primary p-2 rounded-lg text-white"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_77
                      ]),
                      _: 2
                    }, 1032, ["to", "onClick"]),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (updateCommands('paid', undefined, tab.id)),
                      class: "bg-red-500 p-2 rounded-lg text-white",
                      title: "Fechar comanda"
                    }, _hoisted_80, 8, _hoisted_78)
                  ])
                ]),
                (expandedTabId.value === tab.id && tabOrdersLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_81, _hoisted_83))
                  : (expandedTabId.value === tab.id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                        _hoisted_85,
                        (tabOrders.value[tab.id]?.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabOrders.value[tab.id], (order) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: order.id,
                                  class: "bg-white p-2 rounded text-xs border"
                                }, [
                                  _createElementVNode("div", _hoisted_87, [
                                    _createElementVNode("span", _hoisted_88, "Pedido #" + _toDisplayString(order.id), 1),
                                    _createElementVNode("span", {
                                      class: "text-[10px] px-2 py-0.5 rounded",
                                      style: _normalizeStyle({background: getOrderStatusColor(order.status), color: 'white'})
                                    }, _toDisplayString(getOrderStatusLabel(order.status)), 5)
                                  ]),
                                  _createElementVNode("p", _hoisted_89, _toDisplayString(order.items?.length || 0) + " item(ns) - " + _toDisplayString(order.total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1)
                                ]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_90, "Nenhum pedido"))
                      ]))
                    : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_91, [
            _createElementVNode("button", {
              onClick: startAccountSplit,
              class: "w-full p-4 bg-blue-600 text-white rounded-xl font-bold hover:bg-blue-700 transition"
            }, " Dividir Conta "),
            _createElementVNode("button", {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (updateCommands('paid'))),
              class: "w-full p-4 bg-zinc-800 text-white rounded-xl font-bold hover:bg-zinc-700 transition disabled:opacity-50",
              disabled: isLoadingAction.value
            }, [
              (!isLoadingAction.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_93, "Fechar todas"))
                : (_openBlock(), _createElementBlock("span", _hoisted_94, "Processando..."))
            ], 8, _hoisted_92)
          ])
        ])
      ]),
      _: 1
    }, 8, ["isOpen", "toggleModal"]),
    _createVNode(MyModal, {
      isOpen: isAccountSplitModalOpen.value,
      toggleModal: (v) => isAccountSplitModalOpen.value = v
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_95, [
          _createElementVNode("div", _hoisted_96, [
            _hoisted_97,
            _createElementVNode("button", {
              onClick: _cache[9] || (_cache[9] = ($event: any) => (isAccountSplitModalOpen.value = false)),
              class: "text-gray-400 hover:text-gray-600"
            }, [
              (_openBlock(), _createElementBlock("svg", _hoisted_98, _hoisted_100))
            ])
          ]),
          _createElementVNode("div", _hoisted_101, [
            _createElementVNode("div", _hoisted_102, [
              _hoisted_103,
              _createElementVNode("div", _hoisted_104, [
                _createElementVNode("button", {
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (splitNumberOfPeople.value > 2 ? splitNumberOfPeople.value-- : null)),
                  class: "p-2 hover:bg-gray-200 rounded-lg transition"
                }, _hoisted_106),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((splitNumberOfPeople).value = $event)),
                  type: "number",
                  min: "2",
                  class: "text-2xl font-bold text-center w-16 bg-transparent border-b-2 border-primary focus:outline-none"
                }, null, 512), [
                  [
                    _vModelText,
                    splitNumberOfPeople.value,
                    void 0,
                    { number: true }
                  ]
                ]),
                _createElementVNode("button", {
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (splitNumberOfPeople.value++)),
                  class: "p-2 hover:bg-gray-200 rounded-lg transition"
                }, _hoisted_108)
              ])
            ]),
            _createElementVNode("div", _hoisted_109, [
              _createElementVNode("p", _hoisted_110, " Total: " + _toDisplayString(selectedTabTotalAmount.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1),
              _createElementVNode("p", _hoisted_111, " Por pessoa: " + _toDisplayString((selectedTabTotalAmount.value / splitNumberOfPeople.value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1)
            ]),
            _createElementVNode("button", {
              onClick: createAccountSplit,
              disabled: isLoadingAction.value || splitNumberOfPeople.value < 2,
              class: "w-full p-4 bg-primary text-white rounded-2xl font-bold hover:bg-opacity-90 transition disabled:opacity-50"
            }, _toDisplayString(isLoadingAction.value ? 'Processando...' : 'Criar Divisão'), 9, _hoisted_112)
          ])
        ])
      ]),
      _: 1
    }, 8, ["isOpen", "toggleModal"]),
    _createVNode(MyModal, {
      isOpen: isPaymentProgressModalOpen.value,
      toggleModal: (v) => { if (!v) { isPaymentProgressModalOpen.value = false; isAccountSplitModalOpen.value = true; } else { isPaymentProgressModalOpen.value = v } }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_113, [
          _hoisted_114,
          _createElementVNode("div", _hoisted_115, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(splitPaymentProgress.value, (person) => {
              return (_openBlock(), _createElementBlock("div", {
                key: person.index,
                class: _normalizeClass(["flex items-center justify-between p-4 border rounded-2xl", person.paid ? 'bg-green-50 border-green-200' : 'bg-gray-50'])
              }, [
                _createElementVNode("div", _hoisted_116, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["flex items-center justify-center w-8 h-8 rounded-full", person.paid ? 'bg-green-500 text-white' : 'bg-gray-300 text-gray-600']),
                    style: _normalizeStyle(person.paid ? {} : {})
                  }, [
                    (person.paid)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_117, "✓"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_118, _toDisplayString(person.index + 1), 1))
                  ], 6),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_119, "Pessoa " + _toDisplayString(person.index + 1), 1),
                    _createElementVNode("p", _hoisted_120, _toDisplayString(person.amount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1)
                  ])
                ]),
                (!person.paid)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: ($event: any) => (markPersonAsPaid(person.index)),
                      disabled: isLoadingAction.value,
                      class: "px-4 py-2 bg-primary text-white rounded-lg font-bold text-sm hover:bg-opacity-90 transition disabled:opacity-50"
                    }, " Pago ", 8, _hoisted_121))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_122, _hoisted_125))
              ], 2))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_126, [
            _createElementVNode("p", _hoisted_127, _toDisplayString(paidCount.value) + "/" + _toDisplayString(splitNumberOfPeople.value) + " pessoas pagaram ", 1),
            _createElementVNode("div", _hoisted_128, [
              _createElementVNode("div", {
                class: "bg-blue-600 h-2 rounded-full",
                style: _normalizeStyle({ width: ((paidCount.value / splitNumberOfPeople.value) * 100) + '%' })
              }, null, 4)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["isOpen", "toggleModal"])
  ]))
}
}

})